/**
 * Factories container
 */
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import { vendorSelector } from './selectors';
import VendorTeamMembers from '../../Components/VendorTeamMembers/VendorTeamMembers';
import { currentUserSelector } from '../App/selectors';
import { userSelector } from '../User/selectors';
import promisifyActions from '../../Lib/Utils/promisify-actions';
import actions from './actions';

/**
 * Properties to be provided to the bill payment component
 *
 * @param {object} state global state
 */
const mapStateToProps = (state) => ({
  currentUser: currentUserSelector(state),
  user: userSelector(state),
  vendor: vendorSelector(state),
});

const mapDispatchToProps = (dispatch) => ({
  setVendor: (vendor) => dispatch(actions.setVendor(vendor)),
});

/**
 * Connects state to the Vendor Factories component
 *
 * @param {object} mapStateToProps data object to become props for the Factories component
 * @param {object} mapDispatchToProps Factories actions to be dispatched to reducer
 */
export default withRouter(
  connect(
    mapStateToProps,
    promisifyActions(mapDispatchToProps),
  )((props) => <VendorTeamMembers {...props} />),
);
